<div style="position: absolute; top: 30%; left: 30%"><h2>System License is not valid.</h2>
<br>
Please contact your system administrator to resolve this problem.<br>
</div>

